import * as React from 'react';
import { Field, WrappedFieldInputProps } from 'redux-form';
import JRCFormFieldRender, { InputState, JRCWritableFormInputProps } from '../JRCFormFieldRender';
import { useControls } from '../ReduxFormControls';
import { useIntl } from 'react-intl';
import { StyledInput } from '../../JRCStyledInput';

const renderInput = (props: JRCWritableFormInputProps, input: WrappedFieldInputProps, inputState: InputState) => {
    return <StyledInput id={props.name} type="url" {...props} {...input} {...inputState} />;
};

/**
 * Component used as a <input type="url"/> with a url validation
 * @param props JRCWritableFormInputProps
 * validation props: required
 * @returns JSX.Element
 * @deprecated Use JRCInputUrl instead
 */
export const JRCFormUrlField = (props: JRCWritableFormInputProps) => {
    const validate = useControls({
        intl: useIntl(),
        url: true,
        required: props.required,
    });
    return (
        <Field
            component={JRCFormFieldRender}
            renderInputFct={(input: WrappedFieldInputProps, inputState: InputState) =>
                renderInput(props, input, inputState)
            }
            validate={validate}
            htmlFor={props.name}
            {...props}
        />
    );
};
